import { US_STATES, catLabel } from "../lib/constants";

const Panel = ({ title, children, testid }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <p className="font-mono-label text-[10px] text-slate-500 mb-3">{title}</p>
    {children}
  </div>
);

export const ByState = ({ byState, current, onPick }) => {
  const rows = Object.entries(byState || {}).sort((a, b) => b[1] - a[1] || String(a[0]).localeCompare(String(b[0])));
  const max = rows[0]?.[1] || 1;
  const picked = !current || current === "all" ? [] : current.split(",");
  const toggle = (st) => {
    const next = picked.includes(st) ? picked.filter((s) => s !== st) : [...picked, st];
    onPick(next.length ? next.join(",") : "all");
  };
  return (
    <Panel title={onPick ? "Leads by state · tap to add or remove" : "Leads by state"} testid="by-state-panel">
      {!rows.length && <p className="text-sm text-slate-400">No data yet</p>}
      <div className="space-y-1.5 max-h-56 overflow-y-auto pr-1">
        {rows.map(([st, n]) => (
          <button key={st} onClick={onPick ? () => toggle(st) : undefined} disabled={!onPick} data-testid={`by-state-${st}`}
            className={`w-full flex items-center gap-3 text-sm rounded-lg px-2 py-1.5 transition-colors ${picked.includes(st) ? "bg-blue-50 ring-1 ring-blue-200" : onPick ? "hover:bg-slate-50" : "cursor-default"}`}>
            <span className="w-28 text-left truncate text-slate-700">{US_STATES[st] || st}</span>
            <span className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden"><span className="block h-full bg-blue-600 rounded-full" style={{ width: `${(n / max) * 100}%` }} /></span>
            <span className="w-6 text-right font-semibold text-slate-800">{n}</span>
          </button>
        ))}
      </div>
    </Panel>
  );
};

export const ByCategory = ({ byCategory, current, onPick }) => (
  <Panel title="Leads by category" testid="by-category-panel">
    <div className="flex flex-wrap gap-2">
      {Object.entries(byCategory || {}).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).map(([c, n]) => (
        <button key={c} onClick={onPick ? () => onPick(current === c ? "all" : c) : undefined} disabled={!onPick} data-testid={`by-category-${c}`}
          className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${current === c ? "bg-blue-700 text-white border-blue-700" : "bg-slate-50 border-slate-200 text-slate-700 hover:border-blue-300"}`}>
          {catLabel(c)} <b className="ml-1">{n}</b>
        </button>
      ))}
      {!Object.keys(byCategory || {}).length && <p className="text-sm text-slate-400">No data yet</p>}
    </div>
  </Panel>
);

export const ByPos = ({ byPos, current, onPick }) => (
  <Panel title="Current POS in use" testid="by-pos-panel">
    <div className="flex flex-wrap gap-2">
      {Object.entries(byPos || {}).sort((a, b) => b[1] - a[1] || String(a[0]).localeCompare(String(b[0]))).map(([p, n]) => {
        const v = p === "null" || !p ? "unknown" : p;
        return (
          <button key={v} onClick={onPick ? () => onPick(current === v ? "all" : v) : undefined} disabled={!onPick} data-testid={`by-pos-${v}`}
            className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${current === v ? "bg-blue-700 text-white border-blue-700" : "bg-slate-50 border-slate-200 text-slate-700 hover:border-blue-300"}`}>
            {v === "unknown" ? "Unknown" : v} <b className="ml-1">{n}</b>
          </button>
        );
      })}
      {!Object.keys(byPos || {}).length && <p className="text-sm text-slate-400">No data yet</p>}
    </div>
  </Panel>
);

const statusStyle = { running: "text-blue-700", done: "text-slate-700", failed: "text-red-600" };

export const ScanHistory = ({ scans }) => (
  <Panel title="Recent scans" testid="scan-history">
    {!scans.length && <p className="text-sm text-slate-400">No scans yet</p>}
    <div className="space-y-2 max-h-56 overflow-y-auto">
      {scans.slice(0, 10).map((s) => (
        <div key={s.id} className="text-sm border-b border-slate-100 pb-2" data-testid={`scan-row-${s.id}`}>
          <div className="flex justify-between">
            <span className="text-slate-700">{s.state ? US_STATES[s.state] : "All US"} <span className="text-slate-400 text-xs">· {s.trigger}</span></span>
            <span className={`font-semibold text-xs ${statusStyle[s.status]}`}>{s.status === "done" ? `+${s.new} new` : s.status}</span>
          </div>
          {s.status === "running" && <div className="h-1 mt-1.5 rounded-full bg-slate-100 scan-bar" />}
          <p className="text-[11px] text-slate-400">{new Date(s.created_at).toLocaleString()}</p>
        </div>
      ))}
    </div>
  </Panel>
);
